"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _useWebChatUIContext2 = _interopRequireDefault(require("./useWebChatUIContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useInternalRenderMarkdownInline() {
  var _useWebChatUIContext = (0, _useWebChatUIContext2.default)(),
      internalRenderMarkdownInline = _useWebChatUIContext.internalRenderMarkdownInline;

  return internalRenderMarkdownInline;
}

var _default = useInternalRenderMarkdownInline;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VJbnRlcm5hbFJlbmRlck1hcmtkb3duSW5saW5lIiwidXNlV2ViQ2hhdFVJQ29udGV4dCIsImludGVybmFsUmVuZGVyTWFya2Rvd25JbmxpbmUiXSwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9pbnRlcm5hbC91c2VJbnRlcm5hbFJlbmRlck1hcmtkb3duSW5saW5lLmpzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB1c2VXZWJDaGF0VUlDb250ZXh0IGZyb20gJy4vdXNlV2ViQ2hhdFVJQ29udGV4dCc7XG5cbmZ1bmN0aW9uIHVzZUludGVybmFsUmVuZGVyTWFya2Rvd25JbmxpbmUoKSB7XG4gIGNvbnN0IHsgaW50ZXJuYWxSZW5kZXJNYXJrZG93bklubGluZSB9ID0gdXNlV2ViQ2hhdFVJQ29udGV4dCgpO1xuXG4gIHJldHVybiBpbnRlcm5hbFJlbmRlck1hcmtkb3duSW5saW5lO1xufVxuXG5leHBvcnQgZGVmYXVsdCB1c2VJbnRlcm5hbFJlbmRlck1hcmtkb3duSW5saW5lO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7QUFFQSxTQUFTQSwrQkFBVCxHQUEyQztFQUN6QywyQkFBeUMsSUFBQUMsNkJBQUEsR0FBekM7RUFBQSxJQUFRQyw0QkFBUix3QkFBUUEsNEJBQVI7O0VBRUEsT0FBT0EsNEJBQVA7QUFDRDs7ZUFFY0YsK0IifQ==